module.exports = __webpack_public_path__ + "img/DSC_0809.dfc4cb3c.jpeg";